module.exports = __webpack_public_path__ + "img/kladovaya-zdorovya.fe95755.jpg";